// @ts-nocheck
import { Columns } from '../../../table/table.model';

export const tableHeader: Array<Columns> = [
  {
    name: 'id',
    type: 'data',
    label: 'Caso LB+',
    col: 3,
    enableCopy: true,
  },
  {
    name: 'customerLabel',
    type: 'data',
    label: 'Cliente',
    col: 3,
    enableCopy: false,
  },
  {
    name: 'requestingAuthorities',
    type: 'data',
    label: 'Autoridade Solicitante',
    col: 3,
    enableCopy: false,
  },
  {
    name: 'cnjOrProcessNumber',
    type: 'data',
    label: 'Nº do Processo',
    col: 3,
    enableCopy: true,
  },
  {
    name: 'status',
    type: 'data',
    label: 'Status do Caso',
    col: 3,
  },
];

export type QueryStringParameters = {
  idx: string;
  returnFields: string;
  sourceFields: string;
  page: number;
  size: string;
  sort: string;
  extraFields: string;
  search?: string;
  capabilityName: string;
};
